import { render, staticRenderFns } from "./IDCardLayout.vue?vue&type=template&id=115aeef3&"
import script from "./IDCardLayout.vue?vue&type=script&lang=js&"
export * from "./IDCardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports